import styled from "styled-components";

export default function BannerRecupera() {
    return (
        <Content>
            <a href="https://spcrecupera.com.br/">
                <img src="/img/banner-recupera.png" alt="Banner Recupera" />
            </a>
        </Content>
    );
}

const Content = styled.main`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 20px 0;

    a {
        width: 80%;
        max-width: 900px; /* impede que cresça demais em telas grandes */
    }

    img {
        width: 100%;
        height: auto;
        border-radius: 20px;
        transition: transform 0.3s ease;

        :hover {
            cursor: pointer;
            transform: scale(1.02);
        }
    }

    /* RESPONSIVIDADE */
    @media (max-width: 768px) {
        a {
            width: 90%;
        }

        img {
            border-radius: 14px;
        }
    }

    @media (max-width: 480px) {
        a {
            width: 95%;
        }

        img {
            border-radius: 10px;
        }
    }
`;
